import { FormFieldModel, FormFieldValidator } from '@alfresco/adf-core';
import { MasterarbeitsanmeldungVariables } from './masterarbeitsanmeldung.variables';

export class CheckUserProcessAlreadyExists implements FormFieldValidator {

  static USER_PROCESS_ALREADY_EXISTS = 'userProcessAlreadyExists';

  isSupported(field: FormFieldModel): boolean {
    return field.id === MasterarbeitsanmeldungVariables.studium;
  }

  validate(field: FormFieldModel): boolean {
    if (this.isSupported(field)) {
      if(field.params[CheckUserProcessAlreadyExists.USER_PROCESS_ALREADY_EXISTS]) {
        field.validationSummary.message = 'MASTERARBEITSANMELDUNG.ERROR.USER_PROCESS_ALREADY_EXISTS';
        field.validationSummary.attributes = new Map<string, string>();
        field.validationSummary.attributes.set('fieldname', field.name);
        return false;
      }
    }
    return true;
  }
}


